import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12.9075C10.8111 12.9075 13.09 10.6286 13.09 7.8175C13.09 5.00637 10.8111 2.7275 8 2.7275C5.18887 2.7275 2.91 5.00637 2.91 7.8175C2.91 10.6286 5.18887 12.9075 8 12.9075Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.84 4.145V7.9975L9.69 9.415",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.41 13.3575L4.5625 11.575",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.46 11.575L12.6125 13.3575",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.05773 4.62364C1.76452 4.32256 1.60045 3.91891 1.60045 3.49864C1.60045 3.07838 1.76452 2.67473 2.05773 2.37364C2.20015 2.22652 2.3707 2.10953 2.55924 2.02964C2.74778 1.94974 2.95046 1.90857 3.15523 1.90857C3.36 1.90857 3.56267 1.94974 3.75121 2.02964C3.93975 2.10953 4.1103 2.22652 4.25273 2.37364L2.05773 4.62364Z",
			stroke: "currentColor",
			strokeWidth: 1.33
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9436 4.62356C14.2368 4.32247 14.4009 3.91882 14.4009 3.49856C14.4009 3.07829 14.2368 2.67464 13.9436 2.37356C13.8011 2.22643 13.6306 2.10944 13.4421 2.02955C13.2535 1.94965 13.0508 1.90848 12.8461 1.90848C12.6413 1.90848 12.4386 1.94965 12.2501 2.02955C12.0615 2.10944 11.891 2.22643 11.7486 2.37356L13.9436 4.62356Z",
			stroke: "currentColor",
			strokeWidth: 1.33
		})
	]
});
export default SvgAlarmClock;
